/**
 * Time constants expressed in milliseconds
 */

export const ONE_MINUTE = 1 * 60 * 1000;
export const FIVE_MINUTES = 5 * ONE_MINUTE;

export const ONE_HOUR = 60 * ONE_MINUTE;

export const ONE_DAY = 24 * ONE_HOUR;
export const SEVEN_DAYS = 7 * ONE_DAY;
